


































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import SelectableEntity from '@/models/Shared/SelectableEntity';
import ShiftDto from '@/models/Shifts/ShiftDto';
import CreateBookingRoleWorkersRequest from '@/models/BookingRoleWorkers/CreateBookingRoleWorkersRequest';
import BookingRoleWorkerSource from '@/models/BookingRoleWorkers/BookingRoleWorkerSource';
import GiganautVue from '@/components/Shared/GiganautVue';
import ShiftStatus from '@/models/Shifts/ShiftStatus';

@Component({
    name: 'BookingBrowseWorkersOfferRole'
})
export default class extends GiganautVue {
 
  @Prop()
  selectedBookingRole: BookingRoleDto;
  public shifts: SelectableEntity<ShiftDto>[] = [];
  public selectedShiftIds: string[] = [];
  public sendWorkerOfferNotification = false;
  public dialog = false;
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.selectedShiftIds = [];
      const nonCancelledShifts = BookingDetailsModule.selectedBookingRole.shifts.filter(
        shift => shift.status !== ShiftStatus.Cancelled
      )
      this.shifts =  nonCancelledShifts.map(function(shift) {
        return new SelectableEntity<ShiftDto>(shift);
      });
    }
  }

  get loading() {
    return BookingDetailsModule.loadingDialog;
  }

  get selectedWorkerIds() {
      return BookingDetailsModule.browseWorkersVM.selectedWorkerIds;
  }

  async updateSelectedShifts(val: boolean, shift: ShiftDto) {
    	if (val) {
			  this.selectedShiftIds.push(shift.id);
		} else {
			  const index = this.selectedShiftIds.indexOf(shift.id);
        this.selectedShiftIds.splice(index, 1); 
		}
	}

  async confirm() {  
    const request = new CreateBookingRoleWorkersRequest();
    request.bookingRoleId = BookingDetailsModule.browseWorkersVM.bookingRoleId;
    request.workerIds = BookingDetailsModule.browseWorkersVM.selectedWorkerIds;
    request.shiftIds = this.selectedShiftIds;
    request.source = BookingRoleWorkerSource.ManualAgency;
    request.sendWorkerOfferNotification = this.sendWorkerOfferNotification;
    await BookingDetailsModule.createBookingRoleWorkers(request);
    await BookingDetailsModule.updateOfferedSelectedBookingRole(this.selectedBookingRole);
    this.dialog = false;
  }
}
